import { render } from "./WalletTransactionsTab.vue?vue&type=template&id=a388f436&scoped=true"
import script from "./WalletTransactionsTab.vue?vue&type=script&lang=js"
export * from "./WalletTransactionsTab.vue?vue&type=script&lang=js"

import "./WalletTransactionsTab.vue?vue&type=style&index=0&id=a388f436&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a388f436"]])

export default __exports__